/* eslint-disable generator-star-spacing */
/* eslint space-before-function-paren: "off" */
import { toast } from 'react-toastify'
import type { SagaIterator } from 'redux-saga'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Punchlist } from '../../api'
import { errorTextTryingTo } from '../../helpers'
import clientPropertiesActions from './actions'
import { clientPropertiesTypes, FetchClientPropertiesAction } from './types'

export function* fetchClientProperties({ customerId, callback }: FetchClientPropertiesAction): SagaIterator {
  let success = false
  try {
    const properties = yield call(Punchlist.clients.getClientProperties, customerId)
    yield put(clientPropertiesActions.setClientProperties(properties))
    success = true
    if (callback) yield call(callback, success)
  } catch (error) {
    yield call(toast.error, errorTextTryingTo('get the client properties'))
    if (callback) yield call(callback, false)
  }
}

export default function* saga(): SagaIterator {
  yield takeLatest(clientPropertiesTypes.FETCH_CLIENT_PROPERTIES, fetchClientProperties)
}

